module.exports = __webpack_public_path__ + "img/icon-team-type-3.abcb75ad.png";